import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Nineththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };
    return (
        <>
            <style>{`
        :root {
            /* Palette: Premium Trust */
            --primary: #0f172a;
            /* Deep Navy */
            --primary-light: #1e293b;
            --secondary: #10b981;
            /* Emerald */
            --secondary-dark: #059669;
            --accent: #d97706;
            /* Gold/Amber for highlights */
            --bg-light: #f8fafc;
            --bg-white: #ffffff;
            --text-main: #334155;
            --text-light: #64748b;
            --white: #ffffff;

            --font-head: 'Playfair Display', serif;
            --font-body: 'Lato', sans-serif;

            --shadow-subtle: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
            --shadow-card: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            --radius-md: 8px;
            --radius-lg: 16px;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-main);
            background-color: var(--bg-light);
            line-height: 1.6;
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
            font-family: var(--font-head);
            color: var(--primary);
            line-height: 1.25;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: all 0.3s ease;
        }

        ul {
            list-style: none;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
        }

        .section {
            padding: 100px 0;
        }

        /* Buttons */
        .btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 16px 36px;
            font-weight: 700;
            font-size: 1rem;
            border-radius: 50px;
            cursor: pointer;
            transition: all 0.3s ease;
            letter-spacing: 0.5px;
            text-transform: uppercase;
        }

        .btn-primary {
            background-color: var(--secondary);
            color: var(--white);
            border: 2px solid var(--secondary);
            box-shadow: 0 4px 14px 0 rgba(16, 185, 129, 0.39);
        }

        .btn-primary:hover {
            background-color: var(--secondary-dark);
            border-color: var(--secondary-dark);
            transform: translateY(-2px);
        }

        .btn-outline {
            background-color: transparent;
            color: var(--white);
            border: 2px solid var(--white);
        }

        .btn-outline:hover {
            background-color: var(--white);
            color: var(--primary);
        }

        /* Top Contact Bar */
        .top-bar {
            background-color: var(--primary);
            color: #94a3b8;
            font-size: 0.9rem;
            padding: 12px 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .top-bar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .contact-list {
            display: flex;
            gap: 25px;
        }

        .contact-item {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .contact-item span {
            color: var(--white);
        }

        .contact-item i {
            color: var(--secondary);
        }

        /* Hero Section */
        .hero {
            position: relative;
            background: linear-gradient(rgba(15, 23, 42, 0.7), rgba(15, 23, 42, 0.6)), url('https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80');
            background-size: cover;
            background-position: center;
            height: 90vh;
            min-height: 700px;
            display: flex;
            flex-direction: column;
        }

        /* Navigation */
        .navbar {
            padding: 25px 0;
            transition: 0.3s;
            background: rgba(15, 23, 42, 0.9);
            backdrop-filter: blur(10px);
            position: sticky;
            top: 0;
            z-index: 1000;
        }

        .navbar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand-logo {
            font-family: var(--font-head);
            font-size: 2rem;
            font-weight: 700;
            color: var(--white);
            letter-spacing: -0.5px;
        }

        .brand-logo span {
            color: var(--secondary);
        }

        .nav-links {
            display: flex;
            gap: 30px;
        }

        .nav-links a {
            color: var(--white);
            font-weight: 500;
            font-size: 1rem;
            position: relative;
            opacity: 0.9;
        }

        .nav-links a:hover {
            color: var(--secondary);
            opacity: 1;
        }

        .hero-content {
            margin: auto;
            text-align: center;
            max-width: 800px;
            color: var(--white);
        }

        .hero-subtitle {
            display: block;
            font-size: 1.1rem;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 3px;
            color: var(--secondary);
            margin-bottom: 20px;
        }

        .hero-title {
            font-size: 4.5rem;
            margin-bottom: 30px;
            font-weight: 400;
            line-height: 1.1;
        }

        .hero-desc {
            font-size: 1.25rem;
            color: #cbd5e1;
            margin-bottom: 40px;
            font-weight: 300;
            max-width: 600px;
            margin-left: auto;
            margin-right: auto;
        }

        .hero-badges {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-top: 60px;
        }

        .trust-badge {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(5px);
            padding: 10px 20px;
            border-radius: 50px;
            font-size: 0.9rem;
            display: flex;
            align-items: center;
            gap: 10px;
        }

        /* About Section */
        .about-section {
            background-color: var(--bg-white);
        }

        .section-header {
            text-align: center;
            margin-bottom: 70px;
        }

        .section-tag {
            color: var(--secondary);
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            font-size: 0.9rem;
            display: block;
            margin-bottom: 15px;
        }

        .section-title {
            font-size: 3rem;
            color: var(--primary);
            position: relative;
            display: inline-block;
            margin-bottom: 20px;
        }

        .about-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 60px;
            align-items: center;
        }

        .about-image {
            position: relative;
            border-radius: var(--radius-lg);
            overflow: hidden;
            box-shadow: var(--shadow-card);
        }

        .about-image img {
            width: 100%;
            height: auto;
            display: block;
        }

        .experience-badge {
            position: absolute;
            bottom: 30px;
            left: 30px;
            background: var(--primary);
            color: var(--white);
            padding: 20px 30px;
            border-radius: var(--radius-md);
            text-align: center;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .exp-number {
            font-size: 2.5rem;
            font-weight: 700;
            line-height: 1;
            color: var(--secondary);
            font-family: var(--font-head);
            display: block;
        }

        .about-content p {
            font-size: 1.1rem;
            margin-bottom: 25px;
            color: var(--text-light);
        }

        .feature-list li {
            position: relative;
            padding-left: 35px;
            margin-bottom: 15px;
            font-size: 1.05rem;
            color: var(--primary-light);
        }

        .feature-list li::before {
            content: '✓';
            position: absolute;
            left: 0;
            top: 2px;
            color: var(--secondary);
            font-weight: 700;
            font-size: 1.2rem;
        }

        /* Services Section */
        .services-section {
            background-color: #f1f5f9;
        }

        .services-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
        }

        .service-card {
            background: var(--white);
            padding: 40px;
            border-radius: var(--radius-lg);
            transition: 0.4s;
            position: relative;
            overflow: hidden;
            border-bottom: 4px solid transparent;
        }

        .service-card:hover {
            transform: translateY(-10px);
            box-shadow: var(--shadow-card);
            border-bottom-color: var(--secondary);
        }

        .service-icon {
            width: 70px;
            height: 70px;
            background-color: rgba(16, 185, 129, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 25px;
            color: var(--secondary);
            font-size: 1.8rem;
        }

        .service-card h3 {
            font-size: 1.5rem;
            margin-bottom: 15px;
        }

        .service-card p {
            color: var(--text-light);
            margin-bottom: 20px;
            line-height: 1.7;
        }

        .service-link {
            font-weight: 700;
            color: var(--primary);
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 0.95rem;
        }

        .service-link:hover {
            color: var(--secondary);
            gap: 12px;
        }

        /* Gallery Section */
        .gallery-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-template-rows: repeat(2, 280px);
            gap: 20px;
        }

        .gallery-item {
            position: relative;
            border-radius: var(--radius-md);
            overflow: hidden;
            cursor: pointer;
        }

        .gallery-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.6s;
        }

        .gallery-item:hover img {
            transform: scale(1.1);
        }

        .gallery-item.large {
            grid-column: span 2;
            grid-row: span 2;
        }

        .gallery-overlay {
            position: absolute;
            inset: 0;
            background: linear-gradient(to top, rgba(15, 23, 42, 0.8), transparent);
            opacity: 0;
            transition: 0.4s;
            display: flex;
            align-items: flex-end;
            padding: 30px;
        }

        .gallery-item:hover .gallery-overlay {
            opacity: 1;
        }

        .gallery-text h4 {
            color: var(--white);
            font-size: 1.5rem;
            margin-bottom: 5px;
        }

        .gallery-text p {
            color: var(--secondary);
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            font-weight: 600;
        }

        /* Testimonials */
        .testimonial-section {
            background-color: var(--primary);
            color: var(--white);
            background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%231e293b' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }

        .testimonial-section .section-title,
        .testimonial-section .section-tag {
            color: var(--white);
        }

        .testimonial-section .section-tag {
            color: var(--secondary);
        }

        .reviews-wrapper {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
        }

        .review-card {
            background: #1e293b;
            padding: 40px;
            border-radius: var(--radius-lg);
            border: 1px solid rgba(255, 255, 255, 0.05);
        }

        .review-stars {
            color: #fbbf24;
            letter-spacing: 2px;
            margin-bottom: 20px;
            font-size: 1.1rem;
        }

        .review-body {
            font-size: 1.1rem;
            line-height: 1.7;
            font-style: italic;
            color: #cbd5e1;
            margin-bottom: 30px;
        }

        .reviewer-meta {
            display: flex;
            align-items: center;
            gap: 15px;
        }

        .reviewer-avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: var(--secondary);
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            color: var(--white);
            font-size: 1.2rem;
        }

        .reviewer-details h5 {
            color: var(--white);
            font-size: 1.1rem;
            margin-bottom: 2px;
        }

        .reviewer-details span {
            color: var(--secondary);
            font-size: 0.85rem;
            text-transform: uppercase;
        }

        /* Footer */
        footer {
            background-color: var(--primary);
            color: #94a3b8;
            padding-top: 80px;
            border-top: 1px solid #1e293b;
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 2fr 1fr 1fr 1.5fr;
            gap: 40px;
            padding-bottom: 60px;
            border-bottom: 1px solid #1e293b;
        }

        .footer-about h3 {
            color: var(--white);
            font-size: 2rem;
            margin-bottom: 20px;
        }

        .footer-about p {
            line-height: 1.8;
            margin-bottom: 25px;
        }

        .social-links {
            display: flex;
            gap: 15px;
        }

        .social-link {
            width: 40px;
            height: 40px;
            background: #1e293b;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.3s;
        }

        .social-link:hover {
            background: var(--secondary);
            color: var(--white);
        }

        .footer-col h4 {
            color: var(--white);
            font-size: 1.2rem;
            margin-bottom: 25px;
        }

        .footer-links li {
            margin-bottom: 12px;
        }

        .footer-links a:hover {
            color: var(--secondary);
            padding-left: 5px;
        }

        .footer-contact li {
            display: flex;
            margin-bottom: 20px;
            gap: 15px;
            align-items: flex-start;
        }

        .footer-contact i {
            color: var(--secondary);
            margin-top: 5px;
        }

        .copyright {
            text-align: center;
            padding: 25px 0;
            font-size: 0.9rem;
        }

        /* Responsive */
        @media (max-width: 900px) {
            .hero-title {
                font-size: 3.5rem;
            }

            .about-grid,
            .services-grid,
            .reviews-wrapper,
            .footer-grid {
                grid-template-columns: 1fr;
            }

            .top-bar {
                display: none;
            }

            .nav-links {
                display: none;
            }

            .gallery-grid {
                grid-template-columns: 1fr 1fr;
                grid-auto-rows: 200px;
            }

            .gallery-item.large {
                grid-column: span 2;
                grid-row: span 1;
            }
        }
    `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link
                href="https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap"
                rel="stylesheet" />

            {/* Top Contact Bar */}
            <div className="top-bar">
                <div className="container">
                    <div className="contact-list">
                        {get_data.business_location_name && (
                            <div className="contact-item">
                                <i>📍</i> <span>{get_data.business_location_name}</span>
                            </div>
                        )}
                        {get_data.email && (
                            <div className="contact-item">
                                <i>✉️</i> <span>{get_data.email}</span>
                            </div>
                        )}
                        {get_data.mobile && (
                            <div className="contact-item">
                                <i>📞</i> <span>{get_data.mobile}</span>
                            </div>
                        )}
                    </div>
                    <div className="contact-item">
                        <span>Working Hours: Mon-Sat, 9am - 8pm</span>
                    </div>
                </div>
            </div>

            {/* Navigation */}
            <nav className="navbar">
                <div className="container">
                    <a href="#" className="brand-logo">{get_data.service_name}</a>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#about">About Us</a>
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                        <a href="#reviews">Testimonials</a>
                    </div>
                    <a href="#contact" className="btn btn-primary" style={{padding: '12px 24px', fontSize: '0.9rem'}}>Book Service</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                </div>
            </nav>

            {/* Hero Section */}
            <header className="hero">
                <div className="hero-content">
                    <span className="hero-subtitle">Premium Home Care</span>
                    <h1 className="hero-title">Your Home,<br />Perfected.</h1>
                    <p className="hero-desc">Experience the gold standard in residential cleaning, maintenance, and care. Trusted by
                        over 5,000 discerning homeowners.</p>
                    <div style={{display: 'flex', gap: '20px', justifyContent: 'center'}}>
                        <a href="#services" className="btn btn-primary">Our Services</a>
                        <a href="#contact" className="btn btn-outline">Request Quote</a>
                    </div>

                    <div className="hero-badges">
                        <div className="trust-badge">🛡️ Fully Insured</div>
                        <div className="trust-badge">⭐ 4.9/5 Rating</div>
                        <div className="trust-badge">✅ Vetted Pros</div>
                    </div>
                </div>
            </header>

            {/* About Section */}
            <section className="section about-section" id="about">
                <div className="container">
                    <div className="about-grid">
                        <div className="about-image">
                            <img src="https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                                alt="Clean Kitchen" />
                            <div className="experience-badge">
                                <span className="exp-number">15+</span>
                                <span>Years of<br />Excellence</span>
                            </div>
                        </div>
                        <div className="about-content">
                            <div className="section-header" style={{textAlign: 'left', marginBottom: '40px'}}>
                                <span className="section-tag">About Pristine Living</span>
                                <h2 className="section-title">We Don't Just Clean,<br />We Restore.</h2>
                            </div>
                            <p>At Pristine Living, we understand that your home is your sanctuary. That's why we've developed a
                                comprehensive care system that goes beyond surface-level cleaning.</p>
                            <p>Our team consists of background-checked, highly trained professionals who treat your property
                                with the utmost respect. From delicate fabrics to high-end finishes, we know how to care for
                                quality.</p>

                            <ul className="feature-list">
                                <li>100% Satisfaction Guarantee on all services.</li>
                                <li>Eco-friendly, non-toxic premium cleaning products.</li>
                                <li>Dedicated account manager for every client.</li>
                                <li>Flexible scheduling to fit your lifestyle.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="section services-section" id="services">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Our Expertise</span>
                        <h2 className="section-title">Complete Solutions</h2>
                    </div>

                    <div className="services-grid">
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                            <div className="service-card" key={index}>
                                <div className="service-icon">
                                    {item.icon ? (
                                        <img 
                                            src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} 
                                            alt={item.name}
                                            style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%'}}
                                        />
                                    ) : (
                                        <span>✨</span>
                                    )}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.description || 'Service description pending.'}</p>
                                <div style={{display: 'flex', gap: '10px', marginTop: '15px'}}>
                                    <a href={`tel:${get_data.mobile}`} className="btn btn-outline" style={{padding: '10px 20px', fontSize: '0.8rem', color: 'var(--primary)', borderColor: 'var(--primary)'}}>Call</a>
                                    <a href="#contact" className="btn btn-primary" style={{padding: '10px 20px', fontSize: '0.8rem'}}>Enquiry</a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </section>

            {/* Products Section */}
            <section className="section services-section" id="products">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Our Products</span>
                        <h2 className="section-title">Premium Supplies</h2>
                    </div>

                    <div className="services-grid">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="service-card" key={index} style={{padding: '0', overflow: 'hidden'}}>
                                <div style={{height: '200px', overflow: 'hidden'}}>
                                     {item.featured_image ? (<img 
                                        src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                        alt={item.service_name}
                                        style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                    />) : (<div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555', width: '100%', height: '100%', objectFit: 'cover' }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                                </div>
                                <div style={{padding: '30px'}}>
                                    <h3 style={{fontSize: '1.3rem'}}>{item.service_name}</h3>
                                    {item.price && <p style={{color: 'var(--secondary)', fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '10px'}}>₹{item.price}</p>}
                                    <p style={{fontSize: '0.95rem'}}>{item.description || 'Premium quality product.'}</p>
                                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '20px'}}>
                                        <button onClick={() => addToCart(item)} className="btn btn-primary" style={{width: '100%', borderRadius: '4px', fontSize: '0.9rem', padding: '12px'}}>Order Now</button>
                                        <div style={{display: 'flex', gap: '10px'}}>
                                            <a href={`tel:${get_data.mobile}`} className="btn btn-outline" style={{flex: 1, borderRadius: '4px', fontSize: '0.9rem', color: 'var(--primary)', borderColor: 'var(--primary)', padding: '10px'}}>Call</a>
                                            <a href="#contact" className="btn btn-outline" style={{flex: 1, borderRadius: '4px', fontSize: '0.9rem', color: 'var(--primary)', borderColor: 'var(--primary)', padding: '10px'}}>Enquiry</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Testimonials Section */}
            <section className="section testimonial-section" id="reviews">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Client Love</span>
                        <h2 className="section-title">Trusted by Neighbors</h2>
                    </div>

                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div className="reviews-wrapper">
                            {get_data.review_ratings.map((review, index) => (
                                <div className="review-card" key={index}>
                                    <div className="review-stars">
                                        {review.rating && (
                                            <span>{'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}</span>
                                        )}
                                    </div>
                                    <p className="review-body">"{review.review || 'No review data.'}"</p>
                                    <div className="reviewer-meta">
                                        <div className="reviewer-avatar">{(review.user_name || 'U').charAt(0)}</div>
                                        <div className="reviewer-details">
                                            <h5>{review.user_name || 'Valued Client'}</h5>
                                            <span>Verified</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{textAlign: 'center', padding: '40px', color: '#cbd5e1', fontStyle: 'italic'}}>
                            <p>No reviews yet.</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer id="contact">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-about">
                            <h3>{get_data.service_name}</h3>
                            <p>Elevating standards since 2010. We are dedicated to providing the highest quality
                                products and services for discerning clients.</p>
                            <div className="social-links">
                                {get_data.facebook && <a href={get_data.facebook} className="social-link">f</a>}
                                {get_data.twitter && <a href={get_data.twitter} className="social-link">t</a>}
                                {get_data.instagram && <a href={get_data.instagram} className="social-link">ig</a>}
                                {get_data.youtube && <a href={get_data.youtube} className="social-link">yt</a>}
                            </div>
                        </div>

                        <div className="footer-col">
                            <h4>Quick Links</h4>
                            <ul className="footer-links">
                                <li><a href="#">About Us</a></li>
                                <li><a href="#services">Services</a></li>
                                <li><a href="#products">Products</a></li>
                                <li><a href="#reviews">Testimonials</a></li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h4>Services</h4>
                            <ul className="footer-links">
                                <li><a href="#services">All Services</a></li>
                                <li><a href="#products">Our Products</a></li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h4>Contact Us</h4>
                            <ul className="footer-contact">
                                <li>
                                    <i>📍</i>
                                    <span>{get_data.business_location_name}</span>
                                </li>
                                <li>
                                    <i>📞</i>
                                    <span>{get_data.mobile}</span>
                                </li>
                                <li>
                                    <i>✉️</i>
                                    <span>{get_data.email}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="copyright">
                        &copy; {new Date().getFullYear()} {get_data.service_name || 'Partner Company'}. All Rights Reserved.
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Nineththeme
